<template>
    <div>
      <top-img-temp :imgUrl="topImg" :cName="cName" :e-name="eName"></top-img-temp>
      <div class="section2">
        <div class="flexbox">
          <!-- <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"> -->
          <div class="ccc">
           <div  v-for="(item, index) in infoList"
                 v-if="index <= infoList.length/2"
                 :key="index">
             <p class="innerName">{{isChinese ? item.key : item.keyEn}}</p>
             <p class="baseP">{{isChinese ? item.name : item.nameEn}}</p>
             <p class="baseP" >{{isChinese ? '地址' : 'address'}}：{{isChinese ? item.address : item.addressEn}}</p>
             <p class="baseP" >{{isChinese ? '电话' : 'phone'}}：{{item.tel.split("#")[0]}}</p>
             <p class="baseP">{{isChinese ? '邮编' : 'postcode'}}：{{item.tel.split("#")[1]}}</p>
             <p class="baseP">{{isChinese ? '邮箱' : 'e-Mail'}}：{{item.email}}</p>
           </div>
         </div>
          <div class="ccc">
            <div  v-for="(item, index) in infoList"
                  v-if="index > infoList.length/2"
                  :key="index">
              <p class="innerName">{{isChinese ? item.key : item.keyEn}}</p>
              <p class="baseP">{{isChinese ? item.name : item.nameEn}}</p>
              <p class="baseP" >{{isChinese ? '地址' : 'address'}}：{{isChinese ? item.address : item.addressEn}}</p>
              <p class="baseP" >{{isChinese ? '电话' : 'phone'}}：{{item.tel.split("#")[0]}}</p>
              <p class="baseP">{{isChinese ? '邮编' : 'postcode'}}：{{item.tel.split("#")[1]}}</p>
              <p class="baseP">{{isChinese ? '邮箱' : 'e-Mail'}}：{{item.email}}</p>
            </div>
          </div>
          <!-- </el-col> -->
        </div>
      </div>
      <div class="section3">
        <div class="btmBgImg">
          <img src="../../static/images/base/LXWM-34.jpeg" alt="">
          <div class="textbox">
            {{isChinese ? '招聘邮箱：' : 'e-Mail：' }}JSHR@CNJISHI.CN
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import topImgTemp from './baseTemp/topImgTemp'
    export default {
        name: "contactUs",
      data() {
          return {
            isChinese: undefined,
            topImg: require('../../static/images/base/LXWM-33.jpg'),
            cName: '联系我们',
            eName: 'Contact Us',
            infoList: []
          }
      },
      components: {topImgTemp},
      computed: {

        setCAE() {
          return this.$store.state.cAeSatus
        }
      },
      watch:{   // 监听 切换中英文
        // $route( to , from ){
        //   this.isChinese = localStorage.getItem('setCEcontrol') === '1' ? true : false
        // },
        setCAE(newVal) {
          this.isChinese = newVal === 1 ? true : false
        },
      },
      created() {
      this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
      this.getUsInfo()
      this.getTopImg()
      },
      methods: {
        getTopImg() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "联系我们-顶部图片",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              this.topImg = resdata.logo;
            }
          }.bind(this)
        );
    },
          getUsInfo () {
            this.$http
              .get("/jishi/api/contacts/company")
              .then(
                function (res) {
                  if (res && res.data.code === 0) {
                    let resdata = res.data.list
                    this.infoList = resdata
                  }
                }.bind(this)
              )

          }
      }
    }
</script>

<style scoped>
  img {
    width: 100%;
    height: 100%;
  }
  .section2 {
    margin: 0 auto;
    padding: 80px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flexbox {
    width: auto;
    display: flex;
    /*border: 1px solid;*/
  }
  .flexbox>div:nth-child(1){
    border-right: 1px solid black;
    padding-right: 3vw;
  }
  .flexbox>div:nth-child(2){
    margin-left: 3vw;
  }
  .innerName {
    color: #F7B409!important;
    font-size: 2rem!important;
  }
  .baseP {
    font-size: 1.5rem;
    color: #595757;
  }
  .ccc>div{
    margin-top: 3vw;
    padding-right: 4vw;
    border-top: 1px solid;
  }
  .ccc>div:nth-child(1){
    margin-top: 0;
    border-top: none;
  }
  .btmBgImg {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .textbox {
    position: absolute;
    font-size: 4rem;
    color: white;
  }
  
  @media(max-width: 800px){
      .textbox {
    font-size: 3rem;
    text-align: center;
  }
    .flexbox {
    width: auto;
    display: block;
    /*border: 1px solid;*/
  }
  .flexbox>div:nth-child(1){
    /* padding-right: 3vw !important; */
    border-right: 0px solid black;
    margin-left: 3vw
  }
  .flexbox>div:nth-child(2){
    margin-right: 3vw !important;
  }
    .ccc>div{
    /* margin-top: 3vw; */
    /* padding-right: 4vw; */
    border-top: 0px solid;
    border-bottom: 1px solid;
  }
  .section2 {
    padding: 20px 0;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue